import { render, staticRenderFns } from "./CaseTaskData.vue?vue&type=template&id=b975c7fa&scoped=true"
import script from "./CaseTaskData.vue?vue&type=script&lang=js"
export * from "./CaseTaskData.vue?vue&type=script&lang=js"
import style0 from "./CaseTaskData.vue?vue&type=style&index=0&id=b975c7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b975c7fa",
  null
  
)

export default component.exports